export default {
  name: 'st-apexchart',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'line'
    },
    height: {
      type: [String, Number],
      default: undefined
    },
    width: {
      type: [String, Number],
      default: undefined
    },
    options: {
      type: Object,
      default: function () {
        return {}
      }
    },
    series: {
      type: Array,
      default: function () {
        return []
      }
    },
    legendResetKey: {
      type: [String, Number, Boolean],
      default: null
    },
    useStableLegendToggle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hiddenSeriesNames: {}
    }
  },
  computed: {
    safeOptions () {
      return this.options && typeof this.options === 'object' ? this.options : {}
    },
    safeSeries () {
      return Array.isArray(this.series) ? this.series : []
    },
    resolvedSeries () {
      if (!this.useStableLegendToggle) {
        return this.safeSeries
      }

      const hiddenNames = this.hiddenSeriesNames
      return this.safeSeries.map(function (item) {
        const base = item && typeof item === 'object' ? item : {}
        const name = base.name
        const hidden = !!(name && hiddenNames[name])

        if (!hidden) {
          return base
        }

        const sourceData = Array.isArray(base.data) ? base.data : []
        return Object.assign({}, base, {
          data: sourceData.map(function () { return null })
        })
      })
    },
    resolvedOptions () {
      if (!this.useStableLegendToggle) {
        return this.safeOptions
      }

      const self = this
      const incomingOptions = this.safeOptions
      const incomingChart = incomingOptions.chart && typeof incomingOptions.chart === 'object' ? incomingOptions.chart : {}
      const incomingEvents = incomingChart.events && typeof incomingChart.events === 'object' ? incomingChart.events : {}
      const incomingLegend = incomingOptions.legend && typeof incomingOptions.legend === 'object' ? incomingOptions.legend : {}
      const incomingOnItemClick = incomingLegend.onItemClick && typeof incomingLegend.onItemClick === 'object' ? incomingLegend.onItemClick : {}

      const chart = Object.assign({}, incomingChart, {
        events: Object.assign({}, incomingEvents, {
          mounted: function (chartContext, config) {
            self.syncLegendAppearance(chartContext)
            if (typeof incomingEvents.mounted === 'function') {
              incomingEvents.mounted(chartContext, config)
            }
          },
          updated: function (chartContext, config) {
            self.syncLegendAppearance(chartContext)
            if (typeof incomingEvents.updated === 'function') {
              incomingEvents.updated(chartContext, config)
            }
          },
          legendClick: function (chartContext, seriesIndex, config) {
            const seriesName = self.resolveSeriesName(chartContext, seriesIndex)
            if (seriesName) {
              self.toggleSeriesVisibility(seriesName)
              setTimeout(function () {
                self.syncLegendAppearance(chartContext)
              }, 50)
            }

            if (typeof incomingEvents.legendClick === 'function') {
              incomingEvents.legendClick(chartContext, seriesIndex, config)
            }
          }
        })
      })

      const legend = Object.assign({}, incomingLegend, {
        onItemClick: Object.assign({}, incomingOnItemClick, {
          toggleDataSeries: false
        })
      })

      return Object.assign({}, incomingOptions, {
        chart: chart,
        legend: legend
      })
    }
  },
  watch: {
    legendResetKey () {
      this.clearHiddenSeries()
    },
    series () {
      this.pruneHiddenSeries()
    }
  },
  methods: {
    clearHiddenSeries () {
      this.hiddenSeriesNames = {}
    },
    resolveSeriesName (chartContext, seriesIndex) {
      const globals = chartContext && chartContext.w ? chartContext.w.globals : null
      if (!globals || !Array.isArray(globals.seriesNames)) {
        return null
      }

      return globals.seriesNames[seriesIndex] || null
    },
    toggleSeriesVisibility (seriesName) {
      if (!seriesName) {
        return
      }

      if (this.hiddenSeriesNames[seriesName]) {
        this.$delete(this.hiddenSeriesNames, seriesName)
      } else {
        this.$set(this.hiddenSeriesNames, seriesName, true)
      }
    },
    pruneHiddenSeries () {
      if (!this.useStableLegendToggle) {
        return
      }

      const knownSeriesNames = {}
      const source = this.safeSeries
      for (let i = 0; i < source.length; i += 1) {
        const series = source[i]
        const name = series && series.name ? String(series.name) : null
        if (name) {
          knownSeriesNames[name] = true
        }
      }

      Object.keys(this.hiddenSeriesNames).forEach((name) => {
        if (!knownSeriesNames[name]) {
          this.$delete(this.hiddenSeriesNames, name)
        }
      })
    },
    syncLegendAppearance (chartContext) {
      if (!chartContext || !chartContext.el || !chartContext.el.querySelectorAll) {
        return
      }

      const globals = chartContext.w ? chartContext.w.globals : null
      const seriesNames = globals && Array.isArray(globals.seriesNames) ? globals.seriesNames : []
      const legendItems = chartContext.el.querySelectorAll('.apexcharts-legend-series')

      for (let i = 0; i < legendItems.length; i += 1) {
        const item = legendItems[i]
        const name = i < seriesNames.length ? seriesNames[i] : null
        const isHidden = name ? !!this.hiddenSeriesNames[name] : false

        item.style.opacity = isHidden ? '0.45' : '1'
        if (isHidden) {
          if (item.classList && !item.classList.contains('apexcharts-inactive-legend')) {
            item.classList.add('apexcharts-inactive-legend')
          }
        } else if (item.classList && item.classList.contains('apexcharts-inactive-legend')) {
          item.classList.remove('apexcharts-inactive-legend')
        }
      }
    }
  }
}
